import React, { useState, useEffect } from 'react';
import { Button, Select, Upload, message, Form, Spin } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;

const AddArticle = () => {
  const [sections, setSections] = useState([]);
  const [loadingSections, setLoadingSections] = useState(true);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL || ''}/api/sections/active`)
      .then(res => res.json())
      .then(data => {
        setSections(Array.isArray(data) ? data : []);
        setLoadingSections(false);
      })
      .catch(() => {
        setSections([]);
        setLoadingSections(false);
      });
  }, []);

  const handleUploadChange = (info) => {
    let nextList = info.fileList;
    nextList = nextList.slice(-20);
    nextList = nextList.filter(file => {
      if (!file.originFileObj || !file.originFileObj.type || !file.originFileObj.type.startsWith('image/')) {
        message.error(`الملف "${file.name}" ليس صورة`);
        return false;
      }
      if (file.originFileObj.size > 5 * 1024 * 1024) {
        message.error(`حجم الملف "${file.name}" كبير جداً (الحد الأقصى 5 ميجابايت)`);
        return false;
      }
      return true;
    });
    nextList = nextList.map(file => {
      if (file.originFileObj && !file.url && !file.thumbUrl) {
        file.url = URL.createObjectURL(file.originFileObj);
      }
      return file;
    });
    setFileList(nextList);
  };

  const handleSubmit = async (values) => {
    if (!values.sectionId) {
      message.error('يرجى اختيار القسم');
      return;
    }
    const images = fileList.filter(file => file.originFileObj).map(file => file.originFileObj);
    if (images.length === 0) {
      message.error('يرجى اختيار صورة واحدة على الأقل');
      return;
    }

    const section = sections.find(s => s.id === values.sectionId);
    const sectionName = section ? section.name : 'بدون قسم';
    const token = localStorage.getItem('admin_token');
    const today = new Date().toLocaleDateString('ar-EG');

    setSubmitting(true);
    let uploaded = 0;
    try {
      for (let i = 0; i < images.length; i++) {
        const formData = new FormData();
        formData.append('title', `صورة ${sectionName} ${today} #${i + 1}`);
        formData.append('content', 'صورة');
        formData.append('sectionId', values.sectionId);
        formData.append('image', images[i]);

        const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/articles`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`
          },
          body: formData
        });

        if (res.ok) {
          uploaded++;
        } else {
          let errorMsg = 'فشل رفع بعض الصور.';
          try {
            const data = await res.json();
            if (data && data.error) errorMsg = data.error;
            else if (data && data.message) errorMsg = data.message;
          } catch (e) { /* ignore */ }
          message.error(`الصورة "${images[i].name}": ${errorMsg}`);
        }
      }

      if (uploaded > 0) {
        message.success(`تم رفع ${uploaded} ${uploaded === 1 ? 'صورة' : 'صور'} بنجاح`);
        form.resetFields();
        setFileList([]);
      } else {
        message.error('لم يتم رفع أي صورة');
      }
    } catch (err) {
      console.error('خطأ في رفع الصور:', err);
      message.error('تعذر الاتصال بالخادم');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>رفع صور | لوحة التحكم</title>
      </Helmet>
      <div style={{ maxWidth: 700, margin: '0 auto', background: '#fff', padding: 24, borderRadius: 12, boxShadow: '0 2px 8px #eee' }}>
        <h2 style={{ marginBottom: 24 }}>رفع صور للأقسام</h2>
        {loadingSections ? <Spin /> : (
          <>
            <Form layout="vertical" form={form} onFinish={handleSubmit}>
              <Form.Item label="القسم" name="sectionId" rules={[{ required: true, message: 'يرجى اختيار القسم' }]}>
                <Select placeholder="اختر القسم">
                  {sections.map(section => (
                    <Option key={section.id} value={section.id}>{section.name}</Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item label="الصور">
                <Upload
                  multiple
                  listType="picture-card"
                  accept="image/*"
                  beforeUpload={() => false}
                  fileList={fileList}
                  onChange={handleUploadChange}
                >
                  <div>
                    <UploadOutlined />
                    <div style={{ marginTop: 8 }}>اختر الصور</div>
                  </div>
                </Upload>
                <p style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                  يمكنك اختيار عدة صور — كل صورة تُحفظ كمقال مستقل في القسم المحدد. الحد الأقصى لكل صورة 5 ميجابايت.
                </p>
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit" loading={submitting} block>
                  رفع الصور
                </Button>
              </Form.Item>
            </Form>
            <div style={{ marginTop: 24, textAlign: 'left' }}>
              <Button onClick={() => navigate(-1)} type="default">عودة للخلف</Button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddArticle;
